export default __webpack_public_path__ + "static/media/logo.f611e6e8.webp";